import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { User } from 'epc-schema'
import { Navigation, Responsive, Templates, theme } from 'ui'
import { truncate } from 'utils'
import { AccessLevelInput } from './AccessLevelFilters'
import { profileForUser } from './helpers'
import { usePaginatedRoles } from './usePaginatedRoles'
import { SecondaryDrawerPortal } from '../../AppNavigator/SecondaryDrawerPortal'

const { Navigator } = Templates

interface IUserProfileDetailParams {
  [key: string]: string | undefined
  id: string
}

export const AdminRoleNavigationDrawer: React.FC = () => {
  const { drawerActive, drawerCompact } = useContext(
    Responsive.DrawerManagerContext
  )
  const { id } = useParams<IUserProfileDetailParams>()

  const {
    currentPage,
    handlePageClick,
    loading,
    nextPages,
    prevPages,
    users,
    search,
  } = usePaginatedRoles()

  const renderContentItem = (user: User) => {
    return (
      <Navigator.ContentItem
        key={user.id}
        label={truncate(user.emailAddress, 22)}
        maxInitials={2}
        color={theme.colorActionable}
        content={truncate(profileForUser(user), 30)}
        to={`/admin/roles/user/${user.id}${search}`}
        active={id === user.id}
      />
    )
  }

  const contentItems = users?.map((u) => renderContentItem(u as User))

  return (
    <SecondaryDrawerPortal>
      <Navigator.Drawer
        hasSibling={drawerActive}
        hasCompactSibling={drawerCompact}
        theme="secondary"
      >
        <React.Fragment>
          <Navigator.Generic className="py-4">
            <div className="flex-col flex">
              <AccessLevelInput />
            </div>
          </Navigator.Generic>
          {contentItems}
          {loading ? null : (
            <Navigation.PaginationBar
              onPageClick={handlePageClick()}
              currentPage={currentPage}
              nextPages={nextPages}
              previousPages={prevPages}
            />
          )}
        </React.Fragment>
      </Navigator.Drawer>
    </SecondaryDrawerPortal>
  )
}
